<template>
    <div class="listDetailsApp">
        <p v-if="loading" style="width:100%;text-align:center;height:80vh;line-height:80vh"><mt-spinner type="triple-bounce"></mt-spinner></p>
        <div v-if="!loading">
            <p class="list_title_deta">{{listParameter.title}}</p>
            <div class="content_title_app">
                <div class="logo_tit_app">
                    <img class="logo_img_app" src="./img/quyang_logo.png" alt="">
                    <div class="tit_time_app">
                        <span class="logo_tit_img_app">{{listParameter.source}}</span>
                        <span class="logo_time_img_app">{{listParameter.pubDate}}</span>
                    </div>
                </div>
                <div class="speech_app" @click="play()">
                    <img v-if="!voiceUrlPlayif" src="./img/storp.png" style="width:1.2rem;float:left;padding-top:0.2rem" alt="">
                    <img v-if="voiceUrlPlayif" src="./img/play.png" style="width:1.2rem;float:left;padding-top:0.2rem" alt="">
                    <span style="padding-left:0.2rem">语音播报</span>
                    <audio id="audio" style="display:none" :src="voiceUrl"></audio>
                </div>
            </div>
            <div class="preview_information">
                <span>来源：{{listParameter.source}}</span>
                <span>分享：{{listParameter.share_num}}</span>
                <span>预览：{{listParameter.read_num}}</span>
            </div>
            <div class="list_conent">
                <video v-if="listParameter.video_url" style="width:100%" controls="controls"   :poster="listParameter.video_url_pic" :src="listParameter.video_url"></video>
                <p v-html="listParameter.content">{{listParameter.content}}</p>
            </div>
        </div>
        
    </div>
</template>
<script>
import {listDetails,speechInterface,browseInterface,generateSign} from '@/api/index'

const listDetailsParameter ={
    type: 1,
    data: "",
    userId: "",
    appInfoId: "10"
}
const speechParameter ={
    uuid:'',
    text:''
}

const browseParameter ={
    type: 1,
    data: "",
    columnId: "",
    appInfoId: "10"
}
export default {
    data(){
        return {
            loading:true,
            detailsParameter: Object.assign({}, listDetailsParameter),
            voiceParameter: Object.assign({}, speechParameter),
            brParameter: Object.assign({}, browseParameter),

            listParameter:'',
            releaseYears:null,
            releaseMonth:null,
            releaseDay:null,
            releaseTime:null,
            voiceUrl:'',
            voiceUrlPlayif:false
        }
    },
    created(){
        
        let type = this.$route.query.typeNum
        this.detailsParameter.type = this.$route.query.typeNum
        this.detailsParameter.id = this.$route.query.url
        this.brParameter.columnId = this.$route.query.id
        if(type == 1){
            this.detailsParameter.id = this.$route.query.id
            this.brParameter.data = this.$route.query.url
        }else if(type == 2){
            this.detailsParameter.id = this.$route.query.id
        }
        this.details()
    },
    methods:{
        browseFun(){
            const headers = { 
        'Sign': generateSign()
      };
            this.axios.post(browseInterface,this.brParameter,{ headers }).then( res => {
                this.listParameter.read_num++
                // console.log(this.listParameter.read_num,'================')
            })
        },
        async details(){
            const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(listDetails,this.detailsParameter,{ headers })
            this.listParameter = res.data.data[0]
            console.log(this.listParameter.read_num,'---------------------')
            this.releaseYears = res.data.data[0].pubDate.split('-')[0]
            this.releaseMonth = res.data.data[0].pubDate.split('-')[1]
            this.releaseDay = res.data.data[0].pubDate.split('-')[2].split(' ')[0]
            this.releaseTime = res.data.data[0].pubDate.split('-')[2].split(' ')[1]
            // 语音播报
            this.voiceParameter.uuid = res.data.data[0].id
            this.voiceParameter.text = res.data.data[0].content.replace(/<(.[^>]*)>/g,'').replace(/&nbsp;/g,'').replace(/^\s+|\s+$/g,'').replace(/[\r\n]/g,'').replace(/[ ]/g, "")
            this.axios.post(speechInterface,this.voiceParameter,{ headers }).then( res => {
                this.voiceUrl = res.data.data[0]
                setTimeout(() => {
                    this.loading = false
                }, 1000);
                this.browseFun()
            })
        },
        play(){
             if(this.voiceUrlPlayif){
                var audio = document.querySelector('#audio');
                audio.pause();
                this.voiceUrlPlayif = false;
             }else{
                var audio = document.querySelector('#audio');
                audio.play();
                this.voiceUrlPlayif = true;
             }
        }

    }
}
</script>
<style lang="">
    .speech_app{
        background:#e32519;
        font-size:1rem;
        color:#fff;
        height: 1.6rem;
        line-height: 1.6rem;
        padding:0 0.6rem;
        border-radius: 0.8rem;
    }
    .speech_app i{
        font-size:1.2rem;
    }
    .tit_time_app {
        display:flex;
        flex-direction:column;
        padding-left:0.6rem;
    }
    .tit_time_app .logo_tit_img_app{
        font-size: 1.2rem;
        font-family:Source Han Sans CN;
    }
    .tit_time_app .logo_time_img_app{
        font-size:0.8rem;
    }
    .logo_tit_app{
        align-items : center;
        display:flex;
        justify-content: space-between;
    }
    .logo_tit_app .logo_img_app{
        width:3rem;
    }
    .content_title_app{
        display:flex;
        margin-top:1rem;
        align-items : center;
        justify-content: space-between;
    }
    .listDetailsApp{
        margin: 0 0.8rem;
        min-height: calc(100vh - 11.4rem);
    }
    .list_title_deta{
        padding:0.8rem 0;
        font-size: 1.4rem;
        text-align: left;
        font-weight: bolder;
    }
    .preview_information{
        height:1.5rem;
        line-height: 1.5rem;
        text-align: left;
    }
    .preview_information span{
        font-size:0.8rem;
        padding:0 0.4rem;
        border-right:0.02rem solid #646464;
        color:#646464;
    }
    .preview_information span:last-child{
        font-size:0.8rem;
        padding:0 0.4rem;
        border-right:none;
        color:#646464;
    }
    .list_conent{
        padding-top:1.2rem;
    }
    .list_conent img{
        width:100%;
        height:100%;
    }
    .list_conent p{
        font-size: 1.2rem;
        line-height: 1.6rem;
        overflow: hidden;
    }
    .list_conent p span{
        font-size: 1.2rem !important;
        line-height: 1.6rem !important;
    }
    .list_conent div span{
        font-size: 1.2rem !important;
        line-height: 1.6rem !important;
    }
    .list_conent p span img{
        display: block;
    }
    .list_conent div span img{
        display: block;
    }
    .list_conent p span{
        display: block;
    }
    .list_conent div span{
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/components/appModule/homePageApp/appContentList/listDetailsApp/index.vue